module.exports = __webpack_public_path__ + "static/media/doctor-2.90274051.jpg";